module.exports = __webpack_public_path__ + "img/img17.e877fed4.png";